import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

const selectors = {
  block: "[data-product-categories-v2]",
};

const initSwiper = (container) =>
  new Swiper(container.querySelector(".swiper"), {
    //slidesPerView: "auto",
    spaceBetween: 24,
    enabled: true,

    breakpoints: {
      0: {
        slidesPerView: 1,
        slidesPerGroup: 1,
      },
      640: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
      1024: {
        initialSlide: 2,
        slidesPerView: 5,
        centeredSlides: true,
      },
    },

    on: {
      init: (swiper) => {
        swiper.el.style.opacity = '1';
      }
    },

    

    navigation: {
      prevEl: container.querySelector('[data-swiper-navigation="prev"]'),
      nextEl: container.querySelector('[data-swiper-navigation="next"]'),
    },

    pagination: {
      el: container.querySelector("[data-swiper-pagination]"),
    },
  });

const initBlock = (block) => {
  Swiper.use([Navigation, Pagination]);

  initSwiper(block);
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const blocks = document.querySelectorAll(selectors.block);

    blocks?.forEach(initBlock);
  },
  {
    once: true,
  }
);
